import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { useContext, memo, } from 'react';
import { Box, Typography, } from '@mui/material';
import { useTranslation } from 'react-i18next';
import 'katex/dist/katex.min.css';
// Internal dependencies
import { UserContext } from '../auth';
import { workflowStyles } from './workflowStyles';
import { getTools } from './constants';
/**
 * Workflow Prompt Action component
 * @param props Props
 * @returns Prompt Action component
 */
export const ToolAction = memo(function ({ action, }) {
    var _a, _b;
    // Get user credential
    const user = useContext(UserContext);
    // Get translation function
    const { t, i18n } = useTranslation();
    const TOOLS = getTools();
    const tool = action === null || action === void 0 ? void 0 : action.tool;
    return (_jsxs(Box, Object.assign({ sx: { textAlign: 'left' } }, { children: [_jsx(Typography, Object.assign({ sx: Object.assign({}, workflowStyles.actionHeading1) }, { children: t('Tool').toUpperCase() })), _jsx(Typography, Object.assign({ sx: Object.assign(Object.assign({}, workflowStyles.actionHeading2), { margin: '0 0 0.5rem' }) }, { children: (_a = TOOLS[tool]) === null || _a === void 0 ? void 0 : _a.name })), _jsx(Typography, Object.assign({ sx: Object.assign({}, workflowStyles.toolDescription) }, { children: (_b = TOOLS[tool]) === null || _b === void 0 ? void 0 : _b.description })), _jsx(Typography, Object.assign({ sx: Object.assign({}, workflowStyles.actionHeading1) }, { children: t('Prompt') })), _jsx(Typography, Object.assign({ sx: Object.assign(Object.assign({}, workflowStyles.actionHeading2), { margin: '0' }) }, { children: (action === null || action === void 0 ? void 0 : action.promptContent) || '-' }))] })));
});
